<style scoped>
  .stock-picker{
    display: inline-block;
    vertical-align: middle;
  }
  .stock{
    margin-bottom: 5px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<template>
  <div class="stock-picker">
    <Poptip
      transfer
      :disabeld="disabeld"
      width="250"
      :placement="placement"
    >
      <div>
        <slot>请选择</slot>
      </div>
      <div slot="content">
        <i-input
          v-model="params.search"
          size="small"
          placeholder="搜索存货..."
          @on-enter="search"
        >
          <Button
            slot="append"
            icon="ios-search"
            :loading="loading"
            @click="search"
          />
        </i-input>
        <div class="hr" />
        <Button
          v-for="stock in stocks"
          :key="stock.id"
          long
          size="small"
          class="stock"
          @click="selectStock(stock)"
        >
          <span>{{ stock.uid }} - </span>
          <span>{{ stock.name }}</span>
        </Button>
      </div>
    </Poptip>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Number
      },
      placement: {
        type: String,
        default: 'bottom'
      },
      disabeld: {
        type:Boolean,
        default: false
      }
    },
    data() {
      return {
        params: {
          search: '',
        },
        stocks: [],
        loading: false
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      search() {
        this.loading = true;
        this.$util.http.get('stock/sub_stock_search', this.params)
          .then(data => {
            this.loading = false;
            this.stocks = data.items;
            if (this.stocks.length === 0) {
              this.$Message.warning('未搜索到相关存货');
            }
          }).catch((e) => {
            this.$Modal.error({title: '错误', content: e.message});
          }).finally(() => {
            this.loading = false;
          });
      },
      selectStock(stock) {
        this.$emit('input', stock.id);
        this.$emit('on-update', stock);
        this.$parent.$emit('on-form-blur');
        document.body.click();
      }
    }
  }
</script>
